// Text-based logotype matching the supplied mark: "twenty"(white) "one"(lavender)
// with tracked "STUDIOS". Used in nav + footer.
export default function Logo({ className = "", size = "text-2xl", showStudios = false }) {
  return (
    <span className={`inline-flex flex-col leading-none ${className}`}>
      <span className={`${size} tracking-tightest font-light lowercase`}>
        <span className="text-white">twenty</span>
        <span className="text-lav-400">one</span>
      </span>
      {showStudios && (
        <span className="label text-lav-400 mt-1 pl-[2px]">STUDIOS</span>
      )}
    </span>
  );
}
